import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type PointHistory = {
  point_history_id?: number; // 포인트 내역 idx
  parcel_service_id?: number; // 배송/정기배송 idx
  order_reservation_id?: number; // 오더/예약 idx
  rental_id?: number; // 렌탈 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  user_id?: number; // 유저 idx
  organization_id?: number; // 조직 idx
  point?: number; // 포인트
  created_at?: number; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] PointHistory
   * --
   */
  getPointHistories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_POINT_HISTORY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] PointHistory
   * --
   */
  getPointHistory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_POINT_HISTORY, {
        point_history_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PointHistory
   * --
   */
  createPointHistory: async (body: PointHistory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_POINT_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PointHistory
   * --
   */
  updatePointHistory: async (body: PointHistory) => {
    try {
      const { point_history_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_POINT_HISTORY, {
        point_history_id: point_history_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] PointHistory
   * --
   */
  deletePointHistory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_POINT_HISTORY, {
        point_history_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] PointHistory
   * --
   */
  upsertPointHistory: async (body: PointHistory[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.UPSERT_POINT_HISTORY,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] PointHistory
   * --
   */
  usedPointHistory: async (body: PointHistory) => {
    try {
      const res = await $http.post(APIConstant.USE_POINT_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
